<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

definePageMeta({
  // title: 'register',
  layout: 'auth',
  middleware: ['auth'],
  requireLogin: false,
})
useHead({
  title: 'register',
})

const runtimeConfig = useRuntimeConfig()
const userStore = useUserStore()

onMounted(() => {})
</script>
<template>
  <div
    :class="`${
      runtimeConfig.public.source == 'customer' ? 'bg-landing-orange' : ''
    }`"
  >
    <RegisterTwo v-if="runtimeConfig.public.source == 'customer'" />
    <RegisterFirst v-else />
  </div>
</template>

<style lang="scss">

</style>
